"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _ImmutableEngagementModel = require("customer-data-objects/model/ImmutableEngagementModel");

var _QueuesStore = _interopRequireDefault(require("crm_data/queues/QueuesStore"));

var _EngagementsStore = _interopRequireDefault(require("crm_data/engagements/EngagementsStore"));

var _hubspotFluxStores = _interopRequireDefault(require("hubspot.flux.stores.NavigationStore"));

var _QueryTaskPlaylistStore = _interopRequireDefault(require("crm_data/queues/QueryTaskPlaylistStore"));

var _TaskPlaylistStore = _interopRequireDefault(require("crm_data/queues/TaskPlaylistStore"));

var _TaskPlaylistRecord = _interopRequireDefault(require("crm_data/queues/TaskPlaylistRecord"));

var _getValidTasks = _interopRequireDefault(require("./util/getValidTasks"));

var _isAssociatedWithTask = _interopRequireDefault(require("./util/isAssociatedWithTask"));

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var QueuesPlaylistDeps = {
  stores: [_EngagementsStore.default, _QueuesStore.default, _hubspotFluxStores.default, _QueryTaskPlaylistStore.default, _TaskPlaylistStore.default, _IsUngatedStore.default],
  propTypes: {
    subjectId: _propTypes.default.string,
    objectType: _ObjectTypesType.default,
    taskId: _propTypes.default.string,
    queueId: _propTypes.default.string
  },
  deref: function deref(_ref) {
    var taskId = _ref.taskId,
        queueId = _ref.queueId,
        objectType = _ref.objectType,
        subjectId = _ref.subjectId;

    var hasTaskPlaylistOptimizationGate = _IsUngatedStore.default.get('Tasks:ContactsSearchOptimization');

    if (hasTaskPlaylistOptimizationGate) {
      var _title = _TaskPlaylistStore.default.get('title');

      var currentTaskId = _TaskPlaylistStore.default.get('currentTaskId');

      var _taskIds = _TaskPlaylistStore.default.get('taskIds');

      var hasMore = _TaskPlaylistStore.default.get('hasMore');

      var total = _TaskPlaylistStore.default.get('total');

      var _redirectUrl = _TaskPlaylistStore.default.get('redirectUrl');

      if (!_taskIds || !currentTaskId) {
        return undefined;
      }

      var _activeTask = _EngagementsStore.default.get(currentTaskId);

      if (!_activeTask) {
        return undefined;
      }

      if (!(0, _isAssociatedWithTask.default)(_activeTask, objectType, subjectId)) {
        return null;
      }

      var _tasks = _EngagementsStore.default.get(_taskIds);

      var nextTaskIndex = _taskIds.indexOf(currentTaskId) + 1;
      var _nextTask = null;

      if (nextTaskIndex > 0 && nextTaskIndex < _tasks.size) {
        _nextTask = _tasks.get(nextTaskIndex);
      } // next task is loading still


      if (_nextTask === undefined) {
        return undefined;
      }

      return new _TaskPlaylistRecord.default({
        activeTask: _activeTask,
        hasMoreTasks: hasMore,
        nextTaskOffset: nextTaskIndex,
        nextTask: _nextTask,
        tasks: _tasks,
        title: _title,
        totalFromQuery: total,
        redirectUrl: _redirectUrl
      });
    }

    var navigationStore = _hubspotFluxStores.default.get();

    if (!navigationStore) {
      return undefined;
    }

    var queryParams = navigationStore.queryParams || {};
    queueId = queryParams.queueId || queueId;
    taskId = parseInt(queryParams.taskId || taskId, 10);
    var interaction = queryParams.interaction,
        redirectUrl = queryParams.redirectUrl,
        nextTaskOffset = queryParams.nextTaskOffset,
        title = queryParams.title;
    var offset = nextTaskOffset ? parseInt(nextTaskOffset, 10) : null; // if queueId exists then this isn't a query playlist

    if (!taskId || queueId || isNaN(taskId)) {
      return undefined;
    }

    var activeTask = _EngagementsStore.default.get(taskId);

    var QueryTaskPlaylistStoreOptions = {
      offset: offset,
      taskId: taskId
    };

    var taskIds = _QueryTaskPlaylistStore.default.get('taskIds', QueryTaskPlaylistStoreOptions);

    var hasMoreTasks = _QueryTaskPlaylistStore.default.get('hasMore', QueryTaskPlaylistStoreOptions);

    var totalFromQuery = _QueryTaskPlaylistStore.default.get('total', QueryTaskPlaylistStoreOptions);

    if (!taskIds) {
      return undefined;
    }

    var tasks = _EngagementsStore.default.get(taskIds);

    var validTasks = (0, _getValidTasks.default)(tasks, taskId);
    var nextTasks = validTasks.filter(function (currentTask) {
      return taskId !== (0, _ImmutableEngagementModel.getId)(currentTask);
    });
    var nextTask = null;

    if (!nextTasks.isEmpty()) {
      nextTask = nextTasks.first();
    }

    return new _TaskPlaylistRecord.default({
      activeTask: activeTask,
      hasMoreTasks: hasMoreTasks,
      interaction: interaction,
      nextTask: nextTask,
      nextTaskOffset: offset,
      redirectUrl: redirectUrl,
      tasks: validTasks,
      title: title,
      totalFromQuery: totalFromQuery
    });
  }
};
var _default = QueuesPlaylistDeps;
exports.default = _default;
module.exports = exports.default;